import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import { isIgnoredNavigationError } from '@/utils/redirect'
import CPlusPagination from '@/components/CPlusPagination'
import { formatDateTime, formatTableDateTime } from '@/utils/date-time'
import './styles.css'
import './cplus.css'

Vue.use(ElementUI, { size: 'small' })
Vue.component('CPlusPagination', CPlusPagination)
Vue.config.productionTip = false
Vue.prototype.$formatDateTime = formatDateTime
Vue.prototype.$formatTableDateTime = formatTableDateTime

function isExpectedMessageBoxDismissal(error) {
  const action = error && typeof error === 'object' ? error.action : error
  return action === 'cancel' || action === 'close'
}

// Element MessageBox treats closing an alert as a rejected Promise. Most alert
// call sites are fire-and-forget notices, so consume only the expected dismissal
// while preserving real failures as rejected Promises.
const elementAlert = Vue.prototype.$alert
Vue.prototype.$alert = function(...args) {
  return elementAlert.apply(this, args).catch(error => {
    if (isExpectedMessageBoxDismissal(error)) return undefined
    return Promise.reject(error)
  })
}

Vue.config.errorHandler = function(error) {
  if (error && error.authExpired) return
  if (isIgnoredNavigationError(error)) return
  if (isExpectedMessageBoxDismissal(error)) return
  // eslint-disable-next-line no-console
  console.error(error)
}

window.addEventListener('unhandledrejection', event => {
  const error = event && event.reason
  if ((error && error.authExpired) || isIgnoredNavigationError(error) || isExpectedMessageBoxDismissal(error)) {
    event.preventDefault()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
